import { render, staticRenderFns } from "./ProductsFeatured.vue?vue&type=template&id=211c7e61&scoped=true"
import script from "./ProductsFeatured.vue?vue&type=script&lang=js"
export * from "./ProductsFeatured.vue?vue&type=script&lang=js"
import style0 from "./ProductsFeatured.vue?vue&type=style&index=0&id=211c7e61&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "211c7e61",
  null
  
)

export default component.exports